import { render, staticRenderFns } from "./agreementsView.vue?vue&type=template&id=2eeb764e"
import script from "./agreementsView.vue?vue&type=script&lang=js"
export * from "./agreementsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports